
import React, { useEffect, useState } from 'react'
import browser from "browser-detect";
import { useCookies } from "react-cookie";
import login from "../assets/images/login.svg";
import login_logo from "../assets/images/logo_dark.png";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import {
    Alert,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { resendMail } from "../action/user.action"
import { useTranslation } from 'react-i18next';
import { getGeoInfoData, autoLogin } from "../action/user.action";
import { getUserProfile } from "../redux/features/user/userslice";
import { getDefStore } from "../redux/features/defaultstore/defaultStoreSlice";
import { getUserStore } from "../redux/features/userstore/userStoreSlice";
import { getUserDraft } from "../redux/features/draft/mydraftslice";
import { getMyproduct } from "../redux/features/getmyProduct/myProductSlice";
import { getNotify } from "../redux/features/notification/notificationSlice"
import { setUserToken } from "../utils/cookies";
import { getUserWallet } from "../redux/features/wallet/walletslice";
import { toastAlert } from "../utils/toast";

function Thankyou() {
    const navigate = useNavigate();
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const [cookies, setCookie, removeCookie] = useCookies(["name"]);
    const [loginHistory, setLoginHistory] = useState({});

    var data = sessionStorage.getItem("USER_AUTH_VERIFY_TOKEN_DATA");
    useEffect(() => {
        getGeoInfo()
        if (data == null) {
            navigate("/register");
        }
    }, [])


    const getGeoInfo = async () => {
        try {
            let { result } = await getGeoInfoData();
            const browserResult = browser();
            setLoginHistory({
                countryName: result.country_name,
                countryCode: result.country_calling_code,
                ipAddress: result.ip,
                regionName: result.region,
                broswerName: browserResult.name,
                isMobile: browserResult.mobile,
                os: browserResult.os,
            });
        } catch (err) {
            console.log(err);
        }
    };

    const fetchAutoLogin = async () => {
        try {
            let reqdata = {
                token: data,
                ...loginHistory
            }
            const result = await autoLogin(reqdata, dispatch);
            console.log("result", result);

            if (result.status) {
                setCookie("loggedin", true, { path: "/wallet" });

                setUserToken(result.result.token, false);

                dispatch(getUserProfile());
                dispatch(getDefStore());
                dispatch(getUserStore());
                dispatch(getUserDraft());
                dispatch(getMyproduct());
                dispatch(getNotify());
                dispatch(getUserWallet())


                sessionStorage.removeItem("USER_AUTH_VERIFY_TOKEN_DATA");
                setTimeout(() => {
                    navigate("/wallet");

                    // window.location.href = "/wallet";
                }, 1000);

                toastAlert("success", t("LOGIN_SUCCESS"));
            } else {
                toastAlert("success", t(`${result.message}}`));

                navigate("/register");
            }
            // router.push("/dashboard");


        } catch (error) {
            toastAlert("success", t(`${error.message}}`));
            navigate("/register");
            console.log(error)
        }
    }
    useEffect(() => {
        if (data == null) {
            navigate("/register");
        } else {
                    setTimeout(fetchAutoLogin, 2000)

        }
        // fetchAutoLogin()
    }, [])

  
    return (
        <>
            <div className="login">
                <div className="left" >
                    <div className="w-75" >
                        {/* <h2>{t("VERIFY_ACCOUNT")}</h2>  */}
                        <Alert key={"primary"} variant={"success"} className="p-2">
                            <i className="me-2 fa fa-info-circle"></i>
                            {/* Your account has been successfully registered and pending
                            for email verification. If you're not receive
                            email, */}
                            &nbsp;&nbsp;
                            Thank you for registering with DSGIANTS !.
                        </Alert>

                        {/* <a
                            href="/login"
                            className="primary_btn mb-4 w-100">
                            {t("SIGN_IN")}
                        </a> */}
                    </div>
                </div>
                <div className="right d-none d-lg-flex">
                    <div className="text-center" >
                        <img src={login_logo} className="img-fluid mb-4" alt="img" width={200} />
                        <p className="para mb-5" >
                            {/* Log in now to DSGIANTS to better manage your dropshipping account and increase your profits! */}
                            {t("REGLOGIN_CONTENT")}
                        </p>
                        <img src={login} className="img-fluid" alt="img" />

                    </div>
                </div>
            </div>

        </>
    )
}

export default Thankyou